// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChoicesController from "./choices_controller"
application.register("choices", ChoicesController)

import ConfettiController from "./confetti_controller"
application.register("confetti", ConfettiController)

import FaderController from "./fader_controller"
application.register("fader", FaderController)

import FaqController from "./faq_controller"
application.register("faq", FaqController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ProfileDropdownController from "./profile_dropdown_controller"
application.register("profile-dropdown", ProfileDropdownController)
